import React from "react"
import {
  mainNav,
  navList,
  navItemName,
  navItem,
  subNavContainer,
  subNav,
  subNavName,
  subNavItemTitle,
} from "../header.module.scss"
import {
  NavItem,
  SubItemContainer,
  SubItem,
  SubNavItemTitle,
  MainNav,
} from "gatsby-theme-blank/src/components/Layout/Header/MainMenu/main-menu-styled"
import PropTypes from "prop-types"
import ProcessedLink from "gatsby-theme-blank/src/components/processed-link"

const MainMenu = ({ mainMenuData }) => {
  const menuWithoutParent = mainMenuData.filter(
    ({ node }) => !node.drupal_parent_menu_item
  )
  const menuWithParent = mainMenuData.filter(
    ({ node }) => node.drupal_parent_menu_item
  )
  let menuLevelThree
  let menuLevelTwo
  return (
    <MainNav id="top" className={mainNav} role="navigation">
      <ul className={navList}>
        {menuWithoutParent.map((item) => {
          menuLevelTwo = menuWithParent.filter(
            ({ node }) =>
              node.drupal_parent_menu_item ===
              `menu_link_content:${item.node.drupal_id}`
          )
          return (
            <NavItem key={item.node.drupal_id} className={navItem}>
              <div className={navItemName}>
                {menuLevelTwo.length === 0 ? (
                  <ProcessedLink link={item.node.link.uri}>
                    <span tabIndex="-1">{item.node.title}</span>
                  </ProcessedLink>
                ) : (
                  <ProcessedLink link={item.node.link.uri} tabIndex="-1">
                    <span tabIndex="0">{item.node.title}</span>
                  </ProcessedLink>
                )}
              </div>
              {menuLevelTwo.length > 0 && (
                <div className={subNavContainer}>
                  {menuLevelTwo.map((child) => {
                    menuLevelThree = menuWithParent.filter(
                      ({ node }) =>
                        node.drupal_parent_menu_item ===
                        `menu_link_content:${child.node.drupal_id}`
                    )
                    return (
                      <ul key={child.node.drupal_id} className={subNav}>
                        <SubItemContainer className={subNavName}>
                          <ProcessedLink link={child.node.link.uri}>
                            <SubItem>{child.node.title}</SubItem>
                          </ProcessedLink>
                        </SubItemContainer>
                        {menuLevelThree.length > 0 && (
                          <>
                            {menuLevelThree.map((lastChild) => {
                              return (
                                <SubNavItemTitle
                                  key={lastChild.node.drupal_id}
                                  className={subNavItemTitle}
                                >
                                  <ProcessedLink link={lastChild.node.link.uri}>
                                    {lastChild.node.title}
                                  </ProcessedLink>
                                </SubNavItemTitle>
                              )
                            })}
                          </>
                        )}
                      </ul>
                    )
                  })}
                </div>
              )}
            </NavItem>
          )
        })}
      </ul>
    </MainNav>
  )
}

//-----------------------Child Component---------------------------//

MainMenu.propTypes = {
  mainMenuData: PropTypes.array.isRequired,
}

export default MainMenu
